angular.module('exceptionOverride', []).factory('$exceptionHandler', function () {
  return function (exception, cause) {
    if ($window.Bugsnag) {
      Bugsnag.notify(exception, function (event) {
        event.addMetadata('angular', { cause: cause });
      });
    }
  };
});
